import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeOneComponent } from './components/pages/home-one/home-one.component';
import { AboutComponent } from './components/pages/about/about.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { ProductListComponent } from './components/pages/product-list/product-list.component';
import { ProductDetailsComponent } from './components/pages/product-details/product-details.component';
import { FaqComponent } from './components/pages/faq/faq.component';
import { CareersComponent } from './components/pages/careers/careers.component';
import { PrivacyPolicyComponent } from './components/pages/privacy-policy/privacy-policy.component';

const routes: Routes = [
    {path: '', component: HomeOneComponent},
    {path: 'about', component: AboutComponent},
    {path: 'faq', component: FaqComponent},
    {path: 'careers', component: CareersComponent},
    {path: 'products', component: ProductListComponent},
    {path: 'product-details/:productId', component: ProductDetailsComponent},
    {path: 'contact', component: ContactComponent},
    {path: 'privacy-policy', component: PrivacyPolicyComponent},
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule { }
